import { render, staticRenderFns } from "./SupplireFeedback.vue?vue&type=template&id=1fd2806d&"
import script from "./SupplireFeedback.vue?vue&type=script&lang=js&"
export * from "./SupplireFeedback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports